import React from "react";
import {useSelector} from "react-redux";
import {setAuthUser, removeAuthUser} from "redux/actions/Auth";
import {App} from "./apps";
import {Storage} from "./common";
import {Request} from "./request";
import {invalid, type} from "./utils/common";
import {queue} from "./utils/promise";

const _ = require("lodash");

const authStorageKeyHeader = "PrincipalAuth";

function getAuthStorageKey(appName){
  appName = appName || App.current().name;
  if (!appName) throw Error("没有为当前应用域设置名称");
  return `${authStorageKeyHeader}-${appName}`;
}

function Auther(v){

  let _data = {};
  _data.token = v.Token || v.token || null;
  _data.permissionCodes = v.PermissionCodes || v.permissionCodes || [];
  _data.roleCodes = v.RoleCodes || v.roleCodes || [];
  _data.dark = v.Dark || v.dark || false;
  _data.ignoreAuth = v.IgnoreAuth || v.ignoreAuth || false;
  _data.ignoreDark = v.IgnoreDark || v.ignoreDark || false;
  _data.test = v.Test || v.test || false;

  this.token = value => {
    if (invalid(value)) return _data.token;
    return (_data.token = value);
  };

  this.save = () => {
    if (!Principal.isLogined()) return; //没有登录者，返回
    Storage.set(getAuthStorageKey(), _data);
  };

  this.sa = () => {
    return syncAuth(_data,{role: [ "sa" ]}).allow;
  };

  this.test = ()=> _data.test;  //负责人是否在测试环境中使用

  this.verify = ({permission, role, dark},dispatch) => {
    return auth(_data, {permission, role, dark},dispatch);
  };

  this.data = () => {
    return _.cloneDeep(_data);
  };
}

Auther.remove = user => {
  let {Token, PermissionCodes, RoleCodes, Dark, IgnoreAuth, IgnoreDark, Test} = user;
  delete user["Token"];
  delete user["PermissionCodes"];
  delete user["RoleCodes"];
  delete user["Dark"];
  delete user["IgnoreAuth"];
  delete user["IgnoreDark"];
  delete user["Test"];
  return {Token, PermissionCodes, RoleCodes, Dark, IgnoreAuth, IgnoreDark, Test};
};

Auther.clear = () => {
  Storage.removes(key => {
    //清空所有与授权有关的存储信息
    return key.startsWith(`${authStorageKeyHeader}-`);
  });
};

Auther.load = appName => {
  let data = Storage.get(getAuthStorageKey(appName), null);
  if (!data) return null;
  let auth = new Auther(data);
  return auth;
};

export class Principal {
  constructor({dispatch}) {
    this.dispatch = dispatch || App.dispatch();
  }

  current() {
    return Storage.get("user");
  }

  store() {
    let user = this.current();
    this.dispatch(setAuthUser(user));
  }

  signIn(user) {
    let authData = Auther.remove(user); //清理多余的授权信息
    Storage.set("user", user); //保存干净的user
    Principal.setAuther(authData);
    this.dispatch(setAuthUser(user));
  }

  signOut(arg) {  //referrer:退出时是否记录引用页，这样再次登录会返回到当前页
    arg = arg || {};
    const {referrer} = arg;
    Storage.remove("user");
    Principal.clearAuth();
    this.dispatch(removeAuthUser(referrer));
  }

  static isLogined() {
    return Storage.exist("user");
  }

  static getAuther(appName) {
    //返回的时候，给的auther，方便外界使用快捷方法
    return Auther.load(appName);
  }

  static setAuther(data) {
    //data包含授权信息，设置的时候，是根据data设置的
    let auther = new Auther(data);
    auther.save();
    return auther;
  }

  static clearAuth() {
    Auther.clear();
  }

  static refreshToken(token) {
    let auther = Principal.getAuther();
    if (!auther) return;
    auther.token(token);
    auther.save();
  }

  static verify(p,dispatch) {
    let auther = Principal.getAuther();
    return auther.verify(p,dispatch);
  }
}

Request.on("process", response => {
  //截获request收到处理响应的事件
  let token = response.headers["c-token"];
  if (token) {
    //更新token
    Principal.refreshToken(token);
  }
});

// export const Auth = {
//   verify: auth,
//   pipeline: pipeline
// };

function syncAuth(data, {permission, role, dark}){ //同步验证，注意，该验证方式只能验证登录人是否拥有某个角色和某类权限

  if(!data.token) return {allow:false}; //连token都没有，证明没有登录

  if (dark && !inDark()) return {allow:false,dark:true,message:"无灰度功能访问权限"};
    if (!permission && !role) return {allow:true};
    let p = data;

    if (!p) return {allow:false,message:"请登录"}; //没登录就是游客，没有权限
    if (p.ignoreAuth) return {allow:true}; //当前登录者是忽略权限验证的

    if (permission) {
      //指定了需要的权限
      if (type(permission) === "array") permission = {items: permission};
      if (p && p.permissionCodes) {
        let {items, data, url} = permission;
        for (let i = 0; i < items.length; i++) {
          let current = items[i];
          if (invalid(current)) throw new Error("无效的权限配置"); //由于权限码升级，导致老权限码有可能失效，这里要主动提示
          if (type(current) === "string") current = {c: current};
          let {c: code, s: scope} = current;
          if (p.permissionCodes.indexOf(`(${code})`) > -1) {
            if (!scope) return {scope}; //无法立即判断，返回promise对象
            return {allow:true};
          }
        }
      }
    }

    if (role) {
      //指定了需要的角色
      if (type(role) === "string") role = [ role ];
      if (p && p.roleCodes) {
        for (let i = 0; i < role.length; i++) {
          let code = role[i];
          if (invalid(code)) throw new Error("无效的角色配置"); //由于角色码升级，导致老权限码有可能失效，这里要主动提示
          if (p.roleCodes.indexOf(`(${code})`) > -1) {
            return {allow:true};
          }
        }
      }
    }

    return {allow:false,message:"无访问权限"};
}


function auth(data, {permission, role, dark}, dispatch){

  return new Promise((resolve, reject) => {
    try {
      let r = syncAuth(data, {permission, role, dark});
      if(r.scope) return r.scope({data, url, dispatch}).then(resolve).catch(reject); //需要异步判断
      return resolve(r);
    } catch (error) {
        reject(error);
    }
  });
}

// function auth(data, {permission, role, dark}, dispatch){

//   return new Promise((resolve, reject) => {
//     try {
//       if (dark && !inDark()) return resolve({allow:false,dark:true,message:"无灰度功能访问权限"});
//       if (!permission && !role) return resolve({allow:true});
//       let p = data;

//       if (!p) return resolve({allow:false,message:"请登录"}); //没登录就是游客，没有权限
//       if (p.ignoreAuth) return resolve({allow:true}); //当前登录者是忽略权限验证的

//       if (permission) {
//         //指定了需要的权限
//         if (type(permission) === "array") permission = {items: permission};
//         if (p && p.permissionCodes) {
//           let {items, data, url} = permission;
//           for (let i = 0; i < items.length; i++) {
//             let current = items[i];
//             if (invalid(current)) throw new Error("无效的权限配置"); //由于权限码升级，导致老权限码有可能失效，这里要主动提示
//             if (type(current) === "string") current = {c: current};
//             let {c: code, s: scope} = current;
//             if (p.permissionCodes.indexOf(`(${code})`) > -1) {
//               if (scope) return scope({data, url, dispatch}).then(resolve).catch(reject);
//               return resolve({allow:true});
//             }
//           }
//         }
//       }

//       if (role) {
//         //指定了需要的角色
//         if (type(role) === "string") role = [ role ];
//         if (p && p.roleCodes) {
//           for (let i = 0; i < role.length; i++) {
//             let code = role[i];
//             if (invalid(code)) throw new Error("无效的角色配置"); //由于角色码升级，导致老权限码有可能失效，这里要主动提示
//             if (p.roleCodes.indexOf(`(${code})`) > -1) {
//               return resolve({allow:true});
//             }
//           }
//         }
//       }

//       resolve({allow:false,message:"无访问权限"});

//     } catch (error) {
//         reject(error);
//     }
//   });
// }

function inDark(){
  //目前用户是否在灰度中，仅根据登录者来判断，不考虑游客，以后再扩展
  let auther = Principal.getAuther();
  let p = auther ? auther.data() : null;
  if (!p) return;
  return p.dark || p.ignoreDark;
}
